export const LOAD_OHCASES_SUCCESS = "LOAD_OHCASES_SUCCESS";

export const CREATE_OHCASE_SUCCESS = "CREATE_OHCASE_SUCCESS";

export const SAVE_OHCASE_SUCCESS = "SAVE_OHCASE_SUCCESS";

export const DELETE_OHCASE_SUCCESS = "DELETE_OHCASE_SUCCESS";

export const LOAD_OHCASE_DETAIL_SUCCESS = "LOAD_OHCASE_DETAIL_SUCCESS";

export const CANCEL_OHCASE_SUCCESS = "CANCEL_OHCASE_SUCCESS";

export const LOAD_OHCASE_DOCUMENTS_SUCCESS = "LOAD_OHCASE_DOCUMENTS_SUCCESS";

export const LOAD_OHCASE_DOCUMENTS = "LOAD_OHCASE_DOCUMENTS";

export const LOAD_OHCASE_APPOINTMENTS_SUCCESS = "LOAD_OHCASE_APPOINTMENTS_SUCCESS";

export const CREATE_OHCASE = "CREATE_OHCASE";
export const SAVE_OHCASE = "SAVE_OHCASE";

export const CHANGE_WORK_ADJUSTMENT_CASE_SECONDARY_STATUS = "CHANGE_WORK_ADJUSTMENT_CASE_SECONDARY_STATUS";

export const CHANGE_WORK_ADJUSTMENT_CASE_SECONDARY_STATUS_SUCCESS = "CHANGE_WORK_ADJUSTMENT_CASE_SECONDARY_STATUS_SUCCESS";

export const LOAD_LINE_MANAGERS_SUCCESS = "LOAD_LINE_MANAGERS_SUCCESS";

export const LOAD_HR_REPRESENTATIVES_SUCCESS = "LOAD_HR_REPRESENTATIVES_SUCCESS";

export const UPDATE_ADDITIONAL_MANAGERS_SUCCESS = "UPDATE_ADDITIONAL_MANAGERS_SUCCESS";

export const UPDATE_ADDITIONAL_MANAGERS = "UPDATE_ADDITIONAL_MANAGERS";
